export const AUTH_PROVIDER_SALESFORCE = 'salesforce';

export default {
  AUTH_PROVIDER_SALESFORCE
};
